import { createContext, type PropsWithChildren } from 'react'
import { type DataNode } from 'antd/es/tree'

const FilterCategoryStateContext = createContext<Pick<
  FilterCategoryStateProviderProps,
  'state'
> | null>(null)

interface FilterCategoryStateProviderProps extends PropsWithChildren {
  state: {
    appliedItems: DataNode[]
  }
}

export function FilterCategoryStateProvider({
  state,
  children,
}: FilterCategoryStateProviderProps) {
  return (
    <FilterCategoryStateContext.Provider value={{ state }}>
      {children}
    </FilterCategoryStateContext.Provider>
  )
}
